// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"dd236d09","455":"cfc8b7d1","879":"fb555857","977":"fbcfac29"}[chunkId] + ".chunk.js";
};